import React from "react";
import "./TermsConditions.css";

const CookiePolicy = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">Cookie Policy</h1>

        <div className="terms-section">
          <h2>Overview</h2>
          <p>
            This Cookie Policy explains how MAS Mobility Service uses cookies
            and similar technologies when you visit our website. It explains
            what cookies are, why we use them, and your rights regarding their use.
          </p>
        </div>

        <div className="terms-section">
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your computer, smartphone,
            tablet, or other device when you visit a website. They help websites
            function properly, improve performance, remember user preferences,
            and provide useful information to website owners.
          </p>
        </div>

        <div className="terms-section">
          <h2>Types of Cookies We Use</h2>

          <h3>Essential Cookies</h3>
          <p>
            These cookies are necessary for the operation of our website and
            enable secure access, form submission security, and session management.
          </p>

          <h3>Analytics Cookies</h3>
          <p>
            These cookies help us understand how visitors interact with our
            website by collecting anonymous information.
          </p>

          <h3>Functional Cookies</h3>
          <p>
            These cookies remember your preferences such as language and region.
          </p>

          <h3>Advertising & Marketing Cookies</h3>
          <p>
            These cookies help display relevant advertisements and measure
            marketing campaign effectiveness.
          </p>
        </div>

        <div className="terms-section">
          <h2>Why Do We Use Cookies?</h2>
          <p>
            We use cookies to improve website performance, enhance user
            experience, analyze traffic, remember preferences, and maintain security.
          </p>
        </div>

        <div className="terms-section">
          <h2>Third-Party Cookies</h2>
          <p>
            Some cookies may be provided by trusted third-party services such as
            Google Analytics, Google Tag Manager, Cloudflare, and marketing partners.
          </p>
        </div>

        <div className="terms-section">
          <h2>Other Tracking Technologies</h2>
          <p>
            We may also use web beacons and tracking pixels to measure website
            traffic, email campaign performance, and user engagement.
          </p>
        </div>

        <div className="terms-section">
          <h2>Managing Cookies</h2>
          <p>
            Most browsers allow you to view, delete, block, or receive
            notifications about cookies. Disabling certain cookies may affect
            website functionality.
          </p>
        </div>

        <div className="terms-section">
          <h2>Cookie Policy Updates</h2>
          <p>
            We may update this Cookie Policy periodically to reflect changes in
            technology, regulations, or business practices.
          </p>
        </div>

        <div className="terms-section">
          <h2>Contact Us</h2>
          <p>
            MAS Mobility Service<br />
            Jeddah, Kingdom of Saudi Arabia
          </p>

          <p>Email: info@masmobilityservice.com</p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
